var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPaymentMethodsYet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 108,
    viewBox: "0 0 89 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0901 36.6612V62.5012L11.6602 58.7911V32.9412L18.0901 36.6612Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3999 47.8011V73.6511L30.96 69.9311V44.0911L31.6599 44.4911L37.3999 47.8011Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3501 97.7511V105.141L2 67.981V60.6011L66.3501 97.7511Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3501 87.751L66.3501 97.751L2 60.601L11.6602 55.771V58.791L18.0901 62.501L24.3801 59.351L30.9602 56.071V69.931L37.4001 73.651L43.6902 70.511L50.27 67.221V81.081L56.7002 84.801L62.99 81.651L69.8501 78.221L86.3501 87.751Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3496 87.751V95.141L66.3496 105.141V97.751L86.3496 87.751Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3496 39.751V47.141L76.6997 51.971L70.2695 55.181L66.3496 57.141V49.751L70.2695 47.791L72.6396 46.601L79.4895 43.181L86.3496 39.751Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3496 39.7512L79.4895 43.1812L72.6396 46.6012L70.2695 47.7912L66.3496 49.7512L64.7996 47.9712L57.3997 39.4512L56.3997 38.3012L54.5295 36.1512L41.6797 21.3512L34.1797 12.7212L54.1797 2.72119L86.3496 39.7512Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1802 2.72107L34.1802 12.7211L26.6802 12.6911L2 12.6011L22 2.60107L54.1802 2.72107Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3501 49.7511V57.1411L63.55 55.5211L57.4001 51.9711L57.1101 51.8111L50.9602 48.261L44.24 44.3811L38.0901 40.8311L37.8101 40.6611L31.6602 37.1111L24.9402 33.231L18.5 29.5211L2 19.9911V12.6011L26.6802 12.6911L34.1802 12.7211L41.6802 21.3511L54.53 36.1511L56.4001 38.3011L57.4001 39.451L64.8 47.9711L66.3501 49.7511Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7002 51.9712V74.8012L69.8501 78.2212L62.99 81.6512L56.7002 84.8012V58.9512L57.4001 58.6012L63.55 55.5212L66.3501 57.1412L70.27 55.1812L76.7002 51.9712Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5496 55.521L57.3997 58.601L56.6997 58.951L50.9597 55.631L50.2695 55.231L50.9597 54.891L57.1096 51.811L57.3997 51.971L63.5496 55.521Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2397 44.3811L38.0898 47.4611L37.3999 47.8011L31.6599 44.4911L30.96 44.0911L31.6599 43.7411L37.8098 40.6611L38.0898 40.8311L44.2397 44.3811Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9604 48.2611V54.8911L50.2703 55.2311V67.2211L43.6904 70.5111L37.4004 73.6511V47.8011L38.0903 47.4611L44.2402 44.3811L50.9604 48.2611Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6997 58.951V84.801L50.2695 81.081V55.231L50.9597 55.631L56.6997 58.951Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9402 33.231L18.0901 36.661L11.6602 32.941L18.5 29.521L24.9402 33.231Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6599 37.111V43.741L30.96 44.091V56.071L24.3799 59.351L18.0898 62.501V36.661L24.9399 33.231L31.6599 37.111Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPaymentMethodsYet);
export default __webpack_public_path__ + "static/media/no-payment-methods-yet.988226aa9f3465bff90bc9387f7f89fe.svg";
export { ForwardRef as ReactComponent };